
import listArrange from '@/components/temporary/list-arrange'
import divSpan from '@/components/DivSpan';
import listHeaderTemplate from '@/components/list-template/list-header-template'
import Badge from 'vux/src/components/badge/index.vue'

export default {
name: "contractTp",
data() {
return {
listHeaderTemplateBoard: {},
listArrange: [],
approvalTemplateBoard: {}
}
},
created(){
let templateData = this.data;
this.listHeaderTemplateBoard = {
template: listHeaderTemplate.contractQueryV2,
data() {
return {
title: [templateData.contractBase.supplierName],
desc: [templateData.contractBase.companyName]
}
}
},
this.listArrange = [
{
icon: "fa fa-file-text-o font-size-mr",
span: 12,
templateBoard: {
template: "<div-span dictCode='contractType' :dictItemCode=\"dictItemCode\"></div-span>",
data() {
return {
dictItemCode: templateData.contractBase.contractType
}
},
components: {
divSpan
}
}
},
{
icon: "fa fa-calendar-check-o",
span: 12,
templateBoard: {
template: "<span>{{signDate | dateFormat('YYYY-MM-DD')}}</span>",
data() {
return {
signDate: templateData.contractBase.signDate
}
},
}
}
],
this.approvalTemplateBoard = {
template: listHeaderTemplate.contractStatus,
data() {
return {
status: templateData.contractBase.status
}
},
components: {
Badge
}
}
},
props: ['data'],
methods: {},
components: {
listArrange,
divSpan,
listHeaderTemplate
}
}



// WEBPACK FOOTER //
// ./src/components/page-temporary/contractTp.vue